
















export default {
  name: 'FlCopyableText',
  data() {
    return {
      copyString: this.$t('components.copyable_text.copy'),
      isHover: false,
    };
  },
  methods: {
    async copySlotToClipboard() {
      const element = this.$slots.default[0];
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(element.text);
        } else {
          const textArea = document.createElement('textarea');
          textArea.value = element.text;
          textArea.style.position = 'fixed';
          textArea.style.left = '-999999px';
          textArea.style.top = '-999999px';
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          await new Promise((resolve, reject) => {
            const result = document.execCommand('copy');
            textArea.remove();
            if (result) {
              return resolve(result);
            } else {
              return reject();
            }
          });
        }
        this.copyString = this.$t('components.copyable_text.copied');
        setTimeout(() => {
          this.copyString = this.$t('components.copyable_text.copy');
        }, 2000);
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    isHovering() {
      return this.isHover || this.copyString === this.$t('components.copyable_text.copied');
    },
  },
};
